export default {
  one_time: "Einmalig",
  title: "Wählen Sie den passenden Plan",
  subtitle:
    "Alle neuen Benutzer starten mit einem {0}-Tage-Test — entdecken Sie die Pro-Funktionen.",
  free: "Kostenlos",
  basic: "Basic",
  pro: "Pro",
  month: "pro Monat",
  year: "pro Jahr",
  freeSubtitle: "Ideal für Einzelbenutzer und Tests",
  basicSubtitle: "Perfekt für kleine und mittelgroße Unternehmen",
  proSubtitle: "Perfekt für große Unternehmen und professionelle Teams",
  current: "Aktueller Plan",
  current_plan: "Aktueller Plan",
  try: "Kostenlos testen",
  upgrade: "Jetzt upgraden",
  contact: "Kontaktieren Sie uns",
  contact_sales: "Vertrieb kontaktieren",
  calcs: "Berechnungen",
  reports: "Berichte",
  calls_per_month: "Aufrufe/Monat",
  keys: "Schlüssel",
  calculations: "Kohlenstoffemissionsberechnungen",
  f_reports: "PDF-Berichte",
  f_factor: "Grundlegende Emissionsfaktoren",
  f_no_api: "Kein API-Zugriff",
  f_support: "E-Mail-/Tickethilfe",
  priority_support: "Prioritäts-Techniksupport",
  b_reports: "Excel-Berichte",
  b_factor: "Benutzerdefinierte Emissionsfaktoren",
  b_custom_logo: "Benutzerdefiniertes Logo",
  b_api_access: "API-Zugriff",
  p_dedicated_support: "Dedizierter Kundensupport",
  p_custom_solutions: "Individuelle Lösungen",
  p_training: "Teamschulungsdienste",
  refund: "Wenn Sie während des Testzeitraums nicht zufrieden sind, können Sie",
  refund_btn: "eine Rückerstattung beantragen",
  refund_suffix: ".",
  powered_by: "Zahlungsdienste werden bereitgestellt von",
  pay_provider: "paddle",
  paymentLegal: {
    title: "Rechtliche Hinweise zur Zahlung",
    price_currency:
      "Preis: Die Preise werden in EUR angezeigt und sicher über Paddle, unseren bevollmächtigten Händler, abgewickelt. Je nach Standort können zusätzliche Steuern anfallen.",
    vat_tax:
      "Mehrwertsteuer: Geschäftskunden sind für etwaige geltende Steuererklärungen verantwortlich. Wir erheben derzeit keine Mehrwertsteuer direkt, aber Paddle übernimmt die Steuerberechnung beim Checkout, wenn dies erforderlich ist.",
    payment_method:
      "Zahlungen werden sicher über Paddle abgewickelt und unterstützen gängige Kreditkarten, PayPal, Apple Pay und länderspezifische Zahlungsmethoden. Es wird kein Treuhanddienst angeboten.",
    financial_liability:
      "Wir bieten keine Investitions-, Handels- oder Finanzberatungsdienste an. Der Zugang ist ausschließlich auf das SaaS-Abonnement beschränkt.",
    refund_policy: "Rückerstattungsrichtlinie:",
    refund_guarantee:
      "Wir bieten eine 14-tägige Geld-zurück-Garantie für alle ersten Abonnementkäufe über Paddle.",
    refund_request:
      "Rückerstattungsanfragen können über den Abschnitt Abrechnung - Bestellungen oder durch Kontaktaufnahme mit unserem Support-Team jederzeit gestellt werden.",
    right_of_withdrawal:
      "Durch den Zugriff auf oder die Nutzung kostenpflichtiger Funktionen — einschließlich CBAM-Emissionsberechnungen, Berichtsgenerierung, API-Nutzung oder automatisierten Audit-Berechnungen — erkennen Sie an und stimmen zu, dass Ihr Widerrufsrecht gemäß den EU-Verbraucherschutzverordnungen für vollständig bei Nutzung gelieferte digitale Dienstleistungen entfällt.",
    subscription_renewals:
      "Innerhalb von 7 Tagen nach der Verlängerung eingereichte Rückerstattungsanfragen sind für eine Rückerstattung berechtigt. Nach 7 Tagen eingereichte Anfragen können für eine anteilige Rückerstattung basierend auf dem ungenutzten Teil des Abrechnungszeitraums qualifizieren. Für Verlängerungen werden keine Rückerstattungen gewährt, wenn während des aktuellen Abrechnungszyklus bereits kostenpflichtige Funktionen genutzt wurden.",
    buy_what_you_need:
      "Ungenutztes Guthaben kann jederzeit vollständig zurückerstattet werden. Genutztes Guthaben ist nicht rückerstattbar.",
    refund_restrictions:
      "Rückerstattungen können nicht gewährt werden, wenn: Ein CBAM-Bericht generiert wurde. Kohlenstoffemissionsberechnungen oder relevante Audit-Berechnungen durchgeführt wurden. Während des Abrechnungszeitraums ein kostenpflichtiger API-Endpunkt genutzt wurde. Betrug, Missbrauch oder Missbrauch des Dienstes vermutet wird.",
    after_refund_approval:
      "Nach Genehmigung der Rückerstattung: Der Zugriff auf alle kostenpflichtigen Funktionen wird sofort widerrufen. Ihr Konto wird auf den kostenlosen Plan herabgestuft. Alle zukünftigen Verlängerungen werden storniert. Das verbleibende kostenlose Plan-Kontingent wird basierend auf dem ungenutzten Teil der ursprünglichen kostenlosen Zuweisung wiederhergestellt, nicht auf die volle Kapazität zurückgesetzt.",
  },
  vat_note:
    "Die Preise enthalten keine geltende Mehrwertsteuer. EU-Benutzer unterliegen der lokalen Mehrwertsteuer.",
  pay_per_use_desc: "Nutzungsbasierte Bezahlung, kein Abonnement erforderlich",
  pay_per_use_benefits_title: "Vorteile der nutzungsbasierten Bezahlung",
  pay_per_use_benefit1: "Kein Abonnement erforderlich",
  pay_per_use_benefit2: "Nur für das Bezahlen, was Sie nutzen",
  pay_per_use_benefit3: "Lebenslange Gültigkeit",
  buy_credits: "Guthaben kaufen",
  most_popular: "Am beliebtesten",
  save_with_annual: "Sparen Sie {amount} mit dem Jahresplan",
  monthly: "Monatlich",
  annually: "Jährlich",
  enterprise: "Enterprise",
  enterpriseSubtitle: "Maßgeschneiderte Lösungen für professionelle Benutzer",
  e_custom_solutions: "Individuelle Lösungen",
  start_trial: "Bei der Registrierung ist ein {0}-Tage-Test verfügbar",
  all_paid_plans_include_free:
    "Alle kostenpflichtigen Pläne enthalten alles aus dem kostenlosen Plan.",
  fq: {
    title: "FAQ zur Abrechnung und zum Abonnement",
    plans_q: "Welche Abonnementpläne sind verfügbar?",
    plans_a:
      "Wir bieten Kostenlos (100 Berechnungen/Monat), 14-Tage-Test (500 Berechnungen), Basic (49 €/Monat), Pro (99 €/Monat) und nutzungsbasierte Bezahlung (1,5 €/Berechnung) an. Details finden Sie auf der Preisgestaltungsseite.",
    upgrade_q: "Kann ich meinen Plan upgraden oder herabstufen?",
    upgrade_a:
      "Ja, upgraden oder herabstufen Sie sofort in den Kontoeinstellungen. Änderungen treten sofort mit anteiligen Anpassungen in Kraft.",
    trial_q: "Wie funktioniert der kostenlose Test?",
    trial_a:
      "Neue Benutzer erhalten einen {0}-Tage-Test mit allen Pro-Funktionen. Ohne Upgrade läuft er auf den kostenlosen Plan ({1} Berechnungen) zurück.",
    autocharge_q: "Wird mein Abonnement automatisch verlängert?",
    autocharge_a:
      "Ja, die automatische Verlängerung ist standardmäßig aktiviert. Deaktivieren Sie sie jederzeit in den Abrechnungseinstellungen.",
    payment_methods_q: "Welche Zahlungsmethoden werden unterstützt?",
    payment_methods_a:
      "Zahlungen werden sicher über unseren offiziellen Zahlungsanbieter Paddle abgewickelt und unterstützen gängige Kreditkarten, PayPal, Apple Pay und regionale Zahlungsmethoden. Mehrwertsteuer und geltende Steuern werden beim Checkout automatisch von Paddle berechnet.",
    invoice_q: "Stellen Sie rechnungsgerechte Mehrwertsteuer-Rechnungen aus?",
    invoice_a:
      "Ja, rechnungsgerechte Mehrwertsteuer-Rechnungen sind nach Zahlungseingang verfügbar. EU-Kunden müssen eine gültige Umsatzsteuer-Identifikationsnummer haben, um von der Steuerbefreiung zu profitieren.",
    refund_q: "Kann ich eine Rückerstattung beantragen?",
    refund_a:
      "Rückerstattungsanfragen können über die Abonnementseite in den Kontoeinstellungen gestellt werden. Die Rückerstattungsberechtigung richtet sich nach unserer 14-tägigen Rückerstattungsrichtlinie.",
    data_security_q: "Wie sind meine Daten geschützt?",
    data_security_a:
      "Wir halten die DSGVO ein, verwenden verschlüsselte Übertragung und sicheren Speicher. Daten sind privat für Ihr Konto.",
    cancel_q: "Was passiert, wenn ich kündige?",
    cancel_a:
      "Kündigen Sie jederzeit in den Abonnementeinstellungen. Der Zugang bleibt bis zum Ende des Abrechnungszyklus bestehen und geht dann auf den kostenlosen Plan zurück.",
  },
};
